module.exports = __webpack_public_path__ + "static/poradnikThumb-5a49f79a34b0e692aeb45c015b9fe349.webp";